<div class="col-sm-12" class="text-align-center">
    <img src="assets\404error.png" alt="404error">
    <br>
    <button mat-raised-button (click)="goBack()" color="primary">Go Back</button>
</div>